export default "__VITE_ASSET__CSgsPF5W__"